import { getListBySeriaApi, ResponseCode } from "@src/api";
import { sortBySize } from "@src/utils";

export const getSizeList = async (
  seria_guid: string,
): Promise<{ size: string; item_id: string; count: number }[] | null> => {
  const result = await getListBySeriaApi({ seria_guid });

  if (result.code === ResponseCode.OK) {
    const sizes = result.items
      .filter((item) => !item.is_virtual)
      .map((item) => ({ size: item.size, item_id: item.item_id, count: 0 }));

    return sortBySize(sizes);
  }

  return null;
};
